import React from 'react';
import FontAwesome from 'Components/UI/FontAwesome/FontAwesome';
import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';
import { noop } from 'Helpers/PropTypes';
import './index.css';

const Note = ({ note, index, onClick }) => (
  <Draggable key={note.id} draggableId={note.id} index={index}>
    {provided => (
      <div
        className="note"
        role="presentation"
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        onClick={() => onClick(note)}
      >
        <FontAwesome icon="arrows" />
        {note.attributes.content}
      </div>
    )}
  </Draggable>
);

Note.propTypes = {
  note: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  onClick: PropTypes.func,
};

Note.defaultProps = {
  onClick: noop,
};

export default Note;
